/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export const PostClipzyStoreOpServerList = [
  "https://paste.sdjz.wiki",
] as const;

/**
 * 包含加密数据和可选的TTL。
 */
export type PostClipzyStoreRequest = {
  compressedData: string;
  ttl?: number | undefined;
};

export const PostClipzyStoreRequest$zodSchema: z.ZodType<
  PostClipzyStoreRequest
> = z.object({
  compressedData: z.string(),
  ttl: z.number().optional(),
}).describe("包含加密数据和可选的TTL。");

/**
 * 请求体过大。上传的数据（压缩后）超过了服务器限制。
 */
export type PostClipzyStoreRequestEntityTooLargeResponseBody = {
  error?: string | undefined;
  details?: string | undefined;
};

export const PostClipzyStoreRequestEntityTooLargeResponseBody$zodSchema:
  z.ZodType<PostClipzyStoreRequestEntityTooLargeResponseBody> = z.object({
    details: z.string().optional(),
    error: z.string().optional(),
  }).describe("请求体过大。上传的数据（压缩后）超过了服务器限制。");

/**
 * 请求体缺失、格式错误或参数无效。
 */
export type PostClipzyStoreBadRequestResponseBody = {
  error?: string | undefined;
  details?: string | undefined;
};

export const PostClipzyStoreBadRequestResponseBody$zodSchema: z.ZodType<
  PostClipzyStoreBadRequestResponseBody
> = z.object({
  details: z.string().optional(),
  error: z.string().optional(),
}).describe("请求体缺失、格式错误或参数无效。");

/**
 * 片段创建成功！返回该片段的唯一ID。
 */
export type PostClipzyStoreResponseBody = { id?: string | undefined };

export const PostClipzyStoreResponseBody$zodSchema: z.ZodType<
  PostClipzyStoreResponseBody
> = z.object({
  id: z.string().optional(),
}).describe("片段创建成功！返回该片段的唯一ID。");

export type PostClipzyStoreResponse =
  | PostClipzyStoreResponseBody
  | PostClipzyStoreBadRequestResponseBody
  | PostClipzyStoreRequestEntityTooLargeResponseBody;

export const PostClipzyStoreResponse$zodSchema: z.ZodType<
  PostClipzyStoreResponse
> = z.union([
  z.lazy(() => PostClipzyStoreResponseBody$zodSchema),
  z.lazy(() => PostClipzyStoreBadRequestResponseBody$zodSchema),
  z.lazy(() => PostClipzyStoreRequestEntityTooLargeResponseBody$zodSchema),
]);
